import React, { ReactElement } from "react";
import { ColorType, blue, gray, green, pink, purple } from "../../theme";
import { SectionHeader, SectionHeaderProps } from "../sectionHeader";
import styles from "./featureV2.module.scss";
import { Divider } from "@kunduz/ui";
import { Check, ChevronRight } from "@untitled-ui/icons-react";
import Link from "next/link";
import { Button, Text } from "@kunduz/ui-atoms";

export const FeatureWithSummaryItems = (props: Props): ReactElement => {
  const iconColors: any = {
    blue,
    pink,
    purple,
    green,
    gray,
    white: blue,
  };
  const bgColors: any = {
    blue,
    pink,
    purple,
    green,
    gray,
    white: { 25: "#FFF" },
  };

  return (
    <section
      className={styles.base}
      style={{ background: bgColors[props.theme as any][25] }}
    >
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <SectionHeader
            {...props.sectionHeaderProps}
            verticalPadding={false}
            horizontalPadding={false}
          />

          <Divider
            top={0}
            bottom={0}
            color={bgColors[props.theme as any][200]}
          />

          <dl className={styles.summaryList}>
            {props.summaryItems?.map((item, index) => (
              <dd className={styles.summaryItem} key={`dd_${index}`}>
                <Check
                  color={iconColors[props.theme as any][600]}
                  data-role="check"
                />
                {item}
              </dd>
            ))}
          </dl>

          <Divider
            top={0}
            bottom={0}
            color={bgColors[props.theme as any][200]}
          />

          <Button
            as={Link}
            href={props.ctaUrl}
            variant="link"
            color={props.theme as any}
            onClick={props.onCtaClicked}
          >
            <Text variant="textsm" weight="semibold">
              {props.ctaLabel}
            </Text>{" "}
            <ChevronRight />
          </Button>

          {/* <Link href={props.ctaUrl} className={styles.cta}>
          </Link> */}
        </div>
        <div className={styles.right}>
          <img src={props.imageUrl} alt="" loading="lazy" />
        </div>
      </div>
    </section>
  );
};

interface Props {
  theme: ColorType;
  sectionHeaderProps: SectionHeaderProps;
  imageUrl: string;
  summaryItems: string[];
  ctaUrl: string;
  ctaLabel: string;
  onCtaClicked: () => void;
}
